import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as _ from "lodash";
import * as angular from "angular";
import { DefectType } from "../../models/defectType";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import CheckDetectorDefectMappingServiceName, { CheckDetectorDefectMappingService }
  from "../../services/checkDetectorDefectMapping/checkDetectorDefectMapping.service";
import DefectTypeServiceName, { DefectTypeService } from "../../services/defects/defectType.service";
import template from './checkDetectorDefectMapping.tpl.html';
import EditMappingName, { openEditCheckDetectorDefectMapping } from "./editCheckDetectorDefectMapping.controller";
import { States } from "../../shared/config/constant.module";

let requires = [LoaderServiceName, NotifyServiceName, CheckDetectorDefectMappingServiceName, DefectTypeServiceName,
  EditMappingName];

export interface CheckDetectorMappingData {
  checkDetectorText: string;
  defectType: DefectType;
  defectTypes: DefectType[];
}

export interface CheckDetectorDefectMappingController {
  openAddNew(): void;
  getDefectType(defectId: string): DefectType;
  editCheckDetector(checkDetectorDefectMapping: apsViewModels.CheckDetectorDefectMappingItem): void;
}

class CheckDetectorDefectMappingCtrl implements CheckDetectorDefectMappingController {

  private loaderService: LoaderService;
  private notifyService: NotifyService;
  private $modal: mm.foundation.modal;
  private checkDetectorDefectMappingService: CheckDetectorDefectMappingService;
  private defectTypes: DefectType[];
  private checkDetectorDefectMappings: apsViewModels.CheckDetectorDefectMappingItem[];
  private defectTypeService: DefectTypeService;
  private $q: angular.IQService;

  constructor(
    loaderService: LoaderService,
    notifyService: NotifyService,
    $modal: mm.foundation.modal,
    $q: angular.IQService,
    defectTypeService: DefectTypeService,
    checkDetectorDefectMappingService: CheckDetectorDefectMappingService) {
    this.loaderService = loaderService;
    this.notifyService = notifyService;
    this.$modal = $modal;
    this.defectTypeService = defectTypeService;
    this.$q = $q;
    this.checkDetectorDefectMappingService = checkDetectorDefectMappingService;

    let mappingPromise = this.checkDetectorDefectMappingService.getCheckDetectorDefectMappings();
    let defectPromise = this.defectTypeService.getDefectTypesAndClassifications();
    this.$q.all([mappingPromise, defectPromise])
      .then((promises) => {
        this.checkDetectorDefectMappings = promises[0];
        this.defectTypes = _.orderBy(promises[1].types, 'name');
      }, notifyService.handleApiErrors);
  }

  openAddNew(): void {
    openEditCheckDetectorDefectMapping({
      checkDetectorText: '',
      defectTypes: this.defectTypes,
      defectType: null
    }, this.$modal).then((response: apsViewModels.CheckDetectorDefectMappingItem) => {
      if (response) {
        this.checkDetectorDefectMappings.push(response);
      }
    });
  }

  getDefectType(defectId): DefectType {
    return _.find(this.defectTypes, { 'id': defectId });
  }

  editCheckDetector(checkDetectorDefectMapping: apsViewModels.CheckDetectorDefectMappingItem): void {
    openEditCheckDetectorDefectMapping({
      checkDetectorText: checkDetectorDefectMapping.checkDetectorText,
      defectType: this.getDefectType(checkDetectorDefectMapping.defectTypeId),
      defectTypes: this.defectTypes
    }, this.$modal).then((response: apsViewModels.CheckDetectorDefectMappingItem) => {
      if (response) {
        let index = _.findIndex(this.checkDetectorDefectMappings,
          { checkDetectorText: response.checkDetectorText });
        this.checkDetectorDefectMappings[index] = response;
      }
    });
  }
}

export default angular.module('aps.controller.checkDetectorDefectMapping', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.CHECK_DETECTOR_DEFECT_MAPPING,
      url: '/admin/checkDetectorDefectMapping',
      controller: 'CheckDetectorDefectMappingCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Check Detector Defect Mapping',
        vmTitle: 'Check Detector Defect Mapping',
        authorizeAPSIOAdmin: true
      }
    });
  })
  .controller('CheckDetectorDefectMappingCtrl', CheckDetectorDefectMappingCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/checkDetectorDefectMappings/checkDetectorDefectMapping.controller.ts